import 'styles/Unverified.scss'

const Unverified = ({ statusImage, statusText, messageText, voucherCode, setStatus }) => {
    return (
    <div id="unverified-screen">
        <div className="tick">
            <img src={statusImage} alt="" />
        </div>
        <div className="subheading">
            {statusText}
        </div>
        <div className="heading">
            {voucherCode}
        </div>
        <div className="subheading2">
            {messageText}
        </div>
        <div className="back-to-home" onClick={() => setStatus("INIT")}>
            Back to Home
        </div>
    </div>
    );
}

export default Unverified;